import styled from "@emotion/styled";

export const Container = styled.div`
  padding: 20px;
`;

export const ModuleName = styled.p`
  text-transform: capitalize;
`;

export const ModuleIcon = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 5px;
  object-fit: cover;
`;
